const {
    NATIONAL_DOCUMENT,
    PASSPORT_DOCUMENT
} = require('../constants/documentGroups')

const {
    DOCUMENT_CC,
    DOCUMENT_PP
} = require('../constants/documentCodes')

module.exports = {
    lengthId: [8],
    lengthPassport: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    lengthResident: 0,
    patternId: "^[0-9]{8}$",
    patternPassport: "^[a-zA-Z0-9]{4,15}$",
    patternResident: "",
    isValidNationalAlgorith: () => { return true },
    isValidPassportAlgorith: () => { return true },
    isValidResidentAlgorith: () => { return true },
    documentGroupMap: {
        [NATIONAL_DOCUMENT] : [DOCUMENT_CC],
        [PASSPORT_DOCUMENT] : [DOCUMENT_PP]
    }
}